import { mobileLogin } from '../api/api';
import { checkLoginStatus, handleUnauthenticated, setToken, removeToken } from './authManager.js';
import md5 from 'md5';

import axios from 'axios';

// 全局登录态
export let globalAuthState = {
  token: '',
  userId: '',
  isLogin: false,
};

/**
 * 初始化登录态（区分环境）
 */
export async function initAuthState() {
  console.log('初始化登录态...');

  const loginStatus = await checkLoginStatus();
  
  if (loginStatus.isLoggedIn) {
    // 已登录，设置全局状态
    globalAuthState = {
      token: loginStatus.token,
      userId: loginStatus.userId || '',
      isLogin: true,
    };
    
    // 设置默认请求头
    axios.defaults.headers.common['Authorization'] = `Bearer ${loginStatus.token}`;
    console.log(`【${loginStatus.source} 环境】复用登录态：`, globalAuthState);
  } else {
    // 未登录，尝试从JSBridge获取登录状态
    if (window.jsBridge) {
      try {
        console.log('尝试从JSBridge获取登录状态...');
        const userInfo = await window.jsBridge.getUserInfo();
        if (userInfo && userInfo.token) {
          globalAuthState = {
            token: userInfo.token,
            userId: userInfo.userId || '',
            isLogin: true,
          };
          
          // 设置默认请求头
          axios.defaults.headers.common['Authorization'] = `Bearer ${userInfo.token}`;
          setToken(userInfo.token);
          console.log('【JSBridge环境】复用登录态：', globalAuthState);
          return;
        }
      } catch (error) {
        console.warn('从JSBridge获取登录态失败:', error);
      }
    }
    
    // 确实无登录态
    console.log(`【${loginStatus.source} 环境】无登录态`);
    // 注意：这里我们不直接调用 handleUnauthenticated，因为初始化时可能不需要立即跳转
  }
}

/**
 * 检查并处理登录状态
 * @param {Function} routerPush - 路由跳转函数
 */
export async function checkAndHandleAuth(routerPush) {
  const loginStatus = await checkLoginStatus();
  
  if (!loginStatus.isLoggedIn) {
    // 未登录，处理未登录状态
    await handleUnauthenticated(routerPush);
    return false;
  }
  
  // 已登录，更新全局状态
  globalAuthState = {
    token: loginStatus.token,
    userId: loginStatus.userId || '',
    isLogin: true,
  };
  
  // 设置默认请求头
  axios.defaults.headers.common['Authorization'] = `Bearer ${loginStatus.token}`;
  return true;
}

/**
 * 通用登录方法（区分环境）
 * @param params 登录参数（账号/密码等）
 */
export async function login({ mobile, captcha }, router) {
  try {
    const jsonStr = JSON.stringify({
      mobile: mobile,
      captcha: captcha
    })

    // 调用验证短信验证码接口
    mobileLogin({
      sign: md5('moquUser' + jsonStr),
      data: jsonStr,
      mobile: mobile,
      event: 'mobilelogin'
    }).then(async response => {
      if (response.code === 1) {
        // 登录成功，获取用户id作为uid
        // 存储token
        setToken(response.data.userinfo.token)
        
        const { token, userId } = response.data.userinfo;

        // 浏览器环境 → 存储到本地
        localStorage.setItem('browser_token', token);
        localStorage.setItem('browser_userId', userId);
        globalAuthState = { token, userId, isLogin: true };
        console.log('【浏览器环境】登录成功，已存储到本地');
        
        // 同时更新JSBridge的用户信息
        if (window.jsBridge && !window.jsBridge.isInApp) {
          const userInfo = {
            userId: userId,
            token: token,
            mobile: mobile // 传递手机号
          };
          window.jsBridge.setUserInfo(userInfo);
        }

        // 注入请求头
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        // 跳转到首页
        router.push({ path: '/'})
      } else {
        // 登录失败，提示用户
        alert('登录失败，请检查验证码是否正确')
      }
    }).catch(error => {
      // 网络错误等异常情况，提示用户
      alert('网络错误，请稍后重试', error)
      console.log('网络错误，请稍后重试', error)
    })
    
  } catch (error) {
    console.error('登录失败：', error);
    alert('登录失败：' + error);
  }
}

/**
 * 通用登出方法
 */
export async function logout(router) {
  // 清除Cookie中的token
  removeToken();
  
  // 浏览器环境 → 清除本地存储
  localStorage.removeItem('browser_token');
  localStorage.removeItem('browser_userId');
  
  // 同时清除JSBridge的用户信息
  if (window.jsBridge && !window.jsBridge.isInApp) {
    window.jsBridge.clearUserInfo();
  }

  // 通用清理
  delete axios.defaults.headers.common['Authorization'];
  globalAuthState = { token: '', userId: '', isLogin: false };
  // 跳转到登录页
  router.push({ path: '/login'})
}



// 监听登录态变化逻辑（已移除 Capacitor 相关代码）
export function listenAuthStateChange() {
  // 已移除 Capacitor 相关代码
  console.log('已移除 Capacitor 相关代码');
}